import { useEffect, useMemo, useRef } from "react";
import debounce from "lodash.debounce";

// this code originated from https://www.developerway.com/posts/debouncing-in-react
export const useDebouncedFunction = <F>(callback: F, wait: number): F => {
    const ref = useRef<F>();

    useEffect(() => {
        ref.current = callback;
    }, [callback]);

    const debouncedFunction = useMemo(() => {
        // @ts-ignore
        const func = (...args) => {
            // @ts-ignore
            ref.current?.apply(this, args);
        };

        return debounce(func, wait) as F;
    }, []);

    return debouncedFunction;
};
